import {
    handleActions,
    Action,
} from 'redux-actions';
import humanizeString from 'humanize-string';
import {QC_JOBS_STATUSES_SET, QCJobsStatusesPayload} from './QCJobsStatusesAction';
import {QCStatusEnum} from '../../../QCWorkflow/QCFilters/QCFiltersType';
import {QCJobsStatusesState} from '../QCJobsStatusesTypes';

const mapToSelect = (e: QCStatusEnum) => ({
    value: e,
    label: humanizeString(e).replace(/Qc|qc/g, 'QC'),
});

export const setQCJobsStatuses = (state: QCJobsStatusesState, action: Action<QCJobsStatusesPayload>): QCJobsStatusesState => {
    const {payload} = action;
    
    if (payload.length)
        return {
            statuses: payload.map(mapToSelect),
            isLoading: false,
        };
    
    return state;
};

export const initialState = {
    statuses: [],
    isLoading: true,
};

const handlers = {
    [QC_JOBS_STATUSES_SET]: setQCJobsStatuses,
};

export default handleActions(handlers, initialState);
